import React from "react";
import { Input, Select } from "../ui";
import LudDashboardModal from "./LudDashboardModal";

export default function RequestActionModals({
  openModal,
  lang,
  forms,
  appOptions,
  onClose,
  footer,
  title,
  updateForm,
}) {
  return (
    <>
      <LudDashboardModal
        open={openModal === "statement"}
        title={title("كشف حساب", "Statement")}
        onClose={onClose}
        footer={footer}
      >
        <div className="lud-request-modal-form">
          <Select
            label={
              lang === "ar"
                ? "التطبيق"
                : "Application"
            }
            value={forms.statement.app}
            onChange={(event) =>
              updateForm(
                "statement",
                "app",
                event.target.value,
              )
            }
            options={appOptions}
          />

          <div className="lud-request-period">
            <Input
              type="date"
              label={lang === "ar" ? "من" : "From"}
              value={forms.statement.from}
              onChange={(event) =>
                updateForm(
                  "statement",
                  "from",
                  event.target.value,
                )
              }
            />

            <Input
              type="date"
              label={lang === "ar" ? "إلى" : "To"}
              value={forms.statement.to}
              onChange={(event) =>
                updateForm(
                  "statement",
                  "to",
                  event.target.value,
                )
              }
            />
          </div>
        </div>
      </LudDashboardModal>

      <LudDashboardModal
        open={openModal === "taxInvoice"}
        title={title(
          "فاتورة ضريبية",
          "Tax Invoice",
        )}
        onClose={onClose}
        footer={footer}
      >
        <div className="lud-request-modal-form">
          <Select
            label={
              lang === "ar"
                ? "التطبيق"
                : "Application"
            }
            value={forms.taxInvoice.app}
            onChange={(event) =>
              updateForm(
                "taxInvoice",
                "app",
                event.target.value,
              )
            }
            options={appOptions}
          />

          <Input
            type="month"
            label={lang === "ar" ? "الشهر" : "Month"}
            value={forms.taxInvoice.month}
            onChange={(event) =>
              updateForm(
                "taxInvoice",
                "month",
                event.target.value,
              )
            }
          />
        </div>
      </LudDashboardModal>

      <LudDashboardModal
        open={openModal === "contract"}
        title={title("عقد", "Contract")}
        onClose={onClose}
        footer={footer}
      >
        <div className="lud-request-modal-form">
          <Select
            label={
              lang === "ar"
                ? "التطبيق"
                : "Application"
            }
            value={forms.contract.app}
            onChange={(event) =>
              updateForm(
                "contract",
                "app",
                event.target.value,
              )
            }
            options={appOptions}
          />

          <Input
            label={
              lang === "ar"
                ? "ملاحظة (اختياري)"
                : "Note (optional)"
            }
            placeholder={
              lang === "ar"
                ? "تفاصيل إضافية"
                : "Additional details"
            }
            value={forms.contract.note}
            onChange={(event) =>
              updateForm(
                "contract",
                "note",
                event.target.value,
              )
            }
          />
        </div>
      </LudDashboardModal>

      <LudDashboardModal
        open={openModal === "contactManager"}
        title={title(
          "تواصل مدير الحساب",
          "Contact Account Manager",
        )}
        onClose={onClose}
        footer={footer}
      >
        <div className="lud-request-modal-form">
          <Select
            label={
              lang === "ar"
                ? "التطبيق"
                : "Application"
            }
            value={forms.contactManager.app}
            onChange={(event) =>
              updateForm(
                "contactManager",
                "app",
                event.target.value,
              )
            }
            options={appOptions}
          />
        </div>
      </LudDashboardModal>

    </>
  );
}
